// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-slot[data-v-461e6ac6]{color:var(--body-text)}.select-principal.retain-selection[data-v-461e6ac6]{min-height:91px}.select-principal.retain-selection.focused .principal[data-v-461e6ac6]{display:none}", ""]);
// Exports
module.exports = exports;
